export default "__VITE_ASSET__m4QAYkjE__"